import { NavigationGuardNext } from 'vue-router'
import { store } from '../store'

/**
 * TermsGuard
 * 
 * Checks if the user has accepted the Terms of Service.  While admins accept terms
 * during registration, users who join via an Invitation, need to accept terms of
 * service
 * 
 * There is also a use case, when terms are updated, to reset each user's accepted
 * state so that have to accept again.
 */
export default (to, from , next: NavigationGuardNext) => {
    //  Create a 'pass' function
    const pass = () => {
        store.getters.appDebug && console.log('GUARD: terms-guard pass...')
        return next()
    }

    //  Create a 'fail' function
    const fail = () => {
        store.getters.appDebug && console.log('GUARD: terms-guard stop.')

        //  Pop terms form, so user can accept terms
        store.dispatch('dialogOpen', {
            type: 'APP',
            title: 'Terms of Service, Privacy Policy & Use Agreement',
            img: "brandMark",
            component: 'terms-of-service-form',
            overflow: 'auto',
            closeable: false
        })

        //  Allow the user to naviagate to the route, even on fail
        return next()
    }

    //  Fetch the currently authenticated user
    const user = store.getters.user

    //  If the user has accepted terms, guard passes
    if (user.terms_accepted) return pass()

    //  Else, fail
    return fail()
}
